import { Box, Button, Text } from '@auth0/quantum-product';
import React from 'react';
import { login } from '../../../action/navigateAuthentication';
import { useFluxible } from '../../hooks/useFluxible';
import { useTranslation } from '../../hooks/useTranslation';
var Login = function () {
    var fluxibleContext = useFluxible();
    var t = useTranslation('core').t;
    var handleLogin = function () {
        var returnTo = window.location.pathname + window.location.search + window.location.hash;
        fluxibleContext.executeAction(login(returnTo));
    };
    return (React.createElement(Box, { sx: { display: 'flex', gap: 1, alignItems: 'baseline', mb: 1, mt: 1.5 } },
        React.createElement(Button, { size: "small", variant: "outlined", onClick: handleLogin }, t('codeblockOld.header.login.logInButton', 'Log In')),
        React.createElement(Text, { component: "span" }, t('codeblockOld.header.login.configureSnippet', 'to configure this snippet with your account'))));
};
export default Login;
